import { colunaDataConclusao } from './data-conclusao'
import { colunaDataSolicitacao } from './data-solicitacao'
import { colunaProtocolo } from './protocolo'
import { colunaRequerimento } from './requerimento'
import { colunaSituacao } from './situacao'
import { colunaNomeTurma } from './turma'

export const COLUNAS_REQUERIMENTOS = [
  colunaProtocolo(),
  colunaRequerimento(),
  colunaSituacao(),
  colunaNomeTurma(),
  colunaDataSolicitacao(),
  colunaDataConclusao()
]
